import React from 'react';
import { BASE_URL_ATTACH, LOCAL_STORAGE_VAR } from '../../../constants/Common';
import FileUploaded from '../../common/FileUploaded';
import DefaultUser from '../../common/UserProfileDefault';
import find from 'lodash/find';

const DetailItem = (props) => {
  return (
    <div className="detail">
      <span>
        <img src={props.image} alt="" />
      </span>
      <span>{props.value}</span>
    </div>
  );
};

const CardView = (props) => {
  let pd = (props && props.pDetails) || {};
  let cd = (props && props.cDetails) || {};
  let { BUSINESS_TYPE, NATURE_OF_ORG } = JSON.parse(localStorage.getItem(`${LOCAL_STORAGE_VAR}-master`));
  return (
    <div className="KycCardBlock">
      <div className="kycDetailBox d-flex flex-wrap">
        <div className="kycUploadDoc">
          {props.companyDetail &&
            (cd.account?.vendorLogo ? (
              <img src={`${BASE_URL_ATTACH}/${cd.account?.vendorLogo}`} alt="" />
            ) : (
              <DefaultUser size="md-size" />
            ))}
          {props.personalDetails &&
            (pd.profileImage ? (
              <img src={`${BASE_URL_ATTACH}/${pd.profileImage}`} alt="" />
            ) : (
              <DefaultUser size="md-size" />
            ))}
          {/* {props.companyDetail ? (
            <img src={`${BASE_URL_ATTACH}/${cd.account?.vendorLogo}`} alt="" />
          ) : (
            <img src={`${BASE_URL_ATTACH}/${pd.profileImage}`} alt="" />
          )} */}
        </div>
        <div className="kycDetailItem">
          {props.companyDetail && (
            <>
              <div className="">
                <div className="companyNameCode">
                  <span>{cd.account?.name}</span>
                  {cd.account && cd.account?.vendorCode && <span>({cd.account?.vendorCode})</span>}
                </div>
                {cd.account?.companyName && (
                  <div className="detail mt-5">
                    <span>Company Name: </span>
                    <span>
                      {cd.account?.companyName}
                      <span style={{ marginLeft: '15px' }}>Mobile No: </span>
                      {cd.account && (
                        <span>{cd.account?.mobiles && cd.account?.mobiles.length && cd.account?.mobiles}</span>
                      )}
                    </span>
                  </div>
                )}
                {props.companyDetail && cd.account?.businessType && (
                  <div className="detail mt-5">
                    <span>Business Type: </span>
                    <span>{find(BUSINESS_TYPE, { id: [cd.account?.businessType] }).name}</span>
                  </div>
                )}
                {props.companyDetail && cd.account?.businessType && (
                  <div className="detail mt-5">
                    <span>Nature Of Orgs.: </span>
                    <span>{find(NATURE_OF_ORG, { id: [cd.account?.natureOfOrg[0]] }).name}</span>
                  </div>
                )}
              </div>
              {cd.account?.address && (
                <>
                  <div className="detail mt-5">
                    <span>Company Address: </span>
                    {cd.account?.address && <p>{cd.account?.address}</p>}
                    <p>
                      {cd.account?.landMark} , {cd.account?.zipCode && cd.account?.zipCode}
                    </p>
                  </div>
                </>
              )}
              {/* {cd.account?.zipCode && (
                <>
                  <div className="detail mt-5">
                    <span>ZipCode: </span>
                    {cd.account?.zipCode && <p>{cd.account?.zipCode}</p>}
                  </div>
                </>
              )} */}
              {/* {cd.account?.vendorCode && (
                <>
                  <div className="detail mt-5">
                    <span>Company Code: </span>
                    {cd.account?.vendorCode && <p>{cd.account?.vendorCode}</p>}
                  </div>
                </>
              )} */}
            </>
          )}
          {props.companyDetail ? null : (
            <>
              <DetailItem image={require('../../../assets/svg/Profile/user.svg')} value={pd.name} />
              <div className="d-flex">
                <div className="mr-20">
                  {pd.mobile && (
                    <DetailItem
                      image={require('../../../assets/svg/Profile/call.svg')}
                      value={`+${pd.countryCode} ${pd.mobile}`}
                    />
                  )}
                  {pd.whatsapp && (
                    <DetailItem image={require('../../../assets/svg/Profile/whatsapp.svg')} value={pd.whatsapp} />
                  )}
                </div>
                <div>
                  {pd.email && <DetailItem image={require('../../../assets/svg/Profile/email.svg')} value={pd.email} />}
                  {pd.skype && <DetailItem image={require('../../../assets/svg/Profile/skype.svg')} value={pd.skype} />}
                </div>
              </div>
            </>
          )}
        </div>
        <div className="detailEditBloxk" onClick={props.onClick}>
          <img src={require('../../../assets/svg/Profile/edit.svg')} alt="" />
        </div>
      </div>
      {props.companyDetail ? null : (
        <>
          {pd.companyAddress && (
            <div className="kycDetailBox mt-10 addressBlock">
              <div className="kycDetailItem">
                <div className="detail">
                  <span>
                    <img src={require('../../../assets/svg/Profile/location.svg')} alt="" />
                  </span>
                  <span>
                    <p>{pd.companyAddress}</p>
                  </span>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      {(cd.businessId || pd.businessId || pd.photoId) && (
        <FileUploaded
          title={props.companyDetail ? `Business Proof` : `Personal ID`}
          file={
            props.companyDetail
              ? `${BASE_URL_ATTACH}/${cd.businessId || cd.account?.businessId || pd.businessId}`
              : `${BASE_URL_ATTACH}/${pd.photoId}`
          }
          className="mt-20"
        />
      )}
    </div>
  );
};
export default CardView;
